import React from 'react';
import { DatePicker } from 'antd';

import './customDatePicker.scss';

const { RangePicker } = DatePicker;

export const CustomDatePicker = ({ label, value, onChange }) => {
  return (
    <div className="custom-datepicker">
      {label ? (
        <label htmlFor={label} className="custom-datepicker__label">
          {label}
        </label>
      ) : null}
      <RangePicker
        id={label}
        value={value}
        onCalendarChange={(dates, dateStrings) => {
          return onChange(dateStrings);
        }}
        format="YYYY-MM-DD"
      />
    </div>
  );
};
